

















































































import ToolsHelper from '@core/services/tools.helper';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcPosPaymentBalanceDetails from './pos-payment-balance-details.vue';
@Component({
  name: 'bpc-pos-keyboard-v2',
  components: {
    BpcPosPaymentBalanceDetails,
  },
})
export default class PosKeyboardV2 extends Vue {
  @Prop({
    type: Number,
    required: true,
  })
  readonly amountToBePaid!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  readonly value!: number;

  get model(): number {
    return this.value;
  }

  set model(value: number) {
    this.$emit('input', value);
  }

  disableAddButton() {
    return false;
  }

  disableCommaButton() {
    return false;
  }

  clear() {
    this.model = 0;
  }

  modelStr = '';

  add(numberStr: string) {
    const currentDecimalDigits = this.modelStr.split('.')[1];
    const numberOfDecimalDigits = currentDecimalDigits ? currentDecimalDigits.length : 0;

    if (numberOfDecimalDigits >= 2) {
      return;
    }

    if (this.model === 0) {
      this.modelStr = numberStr;
      console.log('this.modelStr', this.modelStr);
      this.model = parseFloat(numberStr);
    } else {
      this.modelStr = `${this.modelStr}${numberStr}`;
      console.log('this.modelStr', this.modelStr);
      this.model = parseFloat(this.modelStr);
    }
  }

  addDecimal() {
    if (this.modelStr.indexOf('.') === -1) {
      this.modelStr = this.modelStr + '.';
      this.model = parseFloat(this.modelStr);
    }
  }

  deleteLastCharacter() {
    if (this.modelStr.length <= 1) {
      this.modelStr = '';
      this.model = 0;
    } else {
      this.modelStr = this.modelStr.slice(0, -1);
      this.model = parseFloat(this.modelStr);
    }
  }

  toggleSign() {
    const modelValue = this.model;
    this.model = -modelValue;
    this.modelStr = `${-modelValue}`;
    console.log('this.modelStr', this.modelStr);
  }

  get disabled() {
    return false; // TODO make it a prop
  }
}
